import { useMantineColors } from "@/hooks";
import { forwardRef } from "react";

export const Icon = forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "stroke" | "strokeWidth" | "viewBox"> & {
    size?: number | string;
    stroke?: number | string;
    filled?: boolean;
    children: React.ReactNode;
  }
>(
  (
    {
      size = 24,
      stroke = 2,
      color,
      className,
      style,
      filled = false,
      children,
      ...rest
    },
    ref
  ) => {
    const colors = useMantineColors();
    const strokeWidth =
      typeof stroke === "number" ? stroke.toString() : stroke || "2";
    const iconColor = color || colors.gray[6];
    const viewBox = "0 0 24 24";
    const iconProps = {
      ref,
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      viewBox: viewBox,
      className: className,
      style: style,
      ...rest,
    };

    if (filled) {
      return <svg {...iconProps}>{children}</svg>;
    }

    return (
      <svg
        {...iconProps}
        fill="none"
        stroke={iconColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {children}
      </svg>
    );
  }
);

Icon.displayName = "Icon";
